






































































































































































import axios from 'axios'
import Vue from 'vue'
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { UAParser } from 'ua-parser-js'

export type AuthData = {
  userId: string,
  password: string,
}

export type DataType = {
  submitImage: any,
  links: any,
  submitTestLinks: any,

  isAuthed: boolean,
  authError: string,
  userId: string,
  password: string,

  isLoading: boolean,
  dropzoneOptions: any,
  vdropzoneErrors: string[],
  vdropzoneSuccessStr: string,

  submitTestLoginId: string,
  submitTestInfo: any[],
  required: any,
}
export default Vue.extend({
  components: {
    vueDropzone,
  },
  data(): DataType {
    return {
      submitImage: require('@/assets/img/top_menu13.png'),
      links: [],
      submitTestLinks: [],

      isAuthed: false,
      authError: '',
      userId: '',
      password: '',

      isLoading: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_ENDPOINT}/api/v1/debug/master_xlsx_upload`,
        method: 'post',
        acceptedFiles: '.xlsx',
        headers: {
          // 'My-Awesome-Header': 'header value',
          // 'access-token': this.$axios.defaults.headers.common['access-token'],
          // 'client': this.$axios.defaults.headers.common['client'],
          // 'uid': this.$axios.defaults.headers.common['uid'],
        },
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        dictDefaultMessage: "<i class='mdi mdi-cloud-upload'></i>マスタファイルをインポートする",
      },
      vdropzoneErrors: [],
      vdropzoneSuccessStr: "",

      submitTestLoginId: '',
      submitTestInfo: [],
      required: (value: string) => !!value || '必須です',
    }
  },
  async mounted() {
    this.tryAuth()
    await this.DumpDataOnServer({})
  },
  computed: {
    userAgent(): string {
      return navigator.userAgent
    },
    uaParserBrowser(): any {
      const uaParser = new UAParser(this.userAgent)
      return uaParser.getBrowser()
    },
    pdfURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/overseas_download`
    },
    manabiURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/manabi`
    },
    // 新サイト用
    newPdfURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/pdf`
    },
    newManabiURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/manabi_ch`
    },
    // TODO: 今後修正予定
    newlinkCrypto() {
      return '4d6a41794e6a41794d6a41784f5449344d5449745a5868304c55784961303161'
    },
    submitTestURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/test_submit`
    },
    isAuthDialog(): boolean {
      return !this.isAuthed
    }
  },
  methods: {
    async DumpDataOnServer(data: any) {
      return await axios.post(
          `/api/v1/debug/dump_data`,
          { "data": data }
        )
    },
    linkFormName(linkId: string, formName: string): string {
      return linkId + formName
    },
    linkSubmitScript(linkId: string, formName: string): string {
      return "javascript:" + this.linkFormName(linkId, formName) + ".submit()"
    },
    loadAuthData(): AuthData | null {
      const authDataText = sessionStorage.getItem('debugAuth')
      if (authDataText) {
        const authData = JSON.parse(authDataText)
        return authData
      } else {
        return null
      }
    },
    saveAuthData(authData: AuthData) {
      sessionStorage.setItem('debugAuth', JSON.stringify(authData))
    },
    tryAuth(): void {
      const authData = this.loadAuthData()
      if (authData) {
        this.userId = authData.userId
        this.password = authData.password
        this.debugAuth()
      }
    },
    debugAuth(): void {
      if (this.userId == "user" && this.password == "pass") {
        this.links = [
          { title: '配送小1', account: '99999999990000000119', name: "h1", crypto: '4f546b354f5445794d7a45774d4441784d546b745957466859574668' },
          { title: '配送小2', account: '99999999990000000005', name: "h2", crypto: '4f546b354f5445794d7a45774d4441774d4455745957466859574668' },
          { title: '配送小3', account: '99999999990000000006', name: "h3", crypto: '4f546b354f5445794d7a45774d4441774d4459745957466859574668' },
          { title: '配送小4', account: '99999999990000000007', name: "h4", crypto: '4f546b354f5445794d7a45774d4441774d4463745957466859574668' },
          { title: '配送小5', account: '99999999990000000008', name: "h5", crypto: '4f546b354f5445794d7a45774d4441774d4467745957466859574668' },
          { title: '配送小6', account: '99999999990000000009', name: "h6", crypto: '4f546b354f5445794d7a45774d4441774d446b745957466859574668' },
          { title: '配送小卒業', account: '99999999990000000010', name: "h7", crypto: '4f546b354f5445794d7a45774d4441774d5441745957466859574668' },
          { /* divider */ },
          { title: '教材小1', account: '99999999990000000120', name: "k1", crypto: '4f546b354f5445794d7a45774d4441784d6a41745957466859574668' },
          { title: '教材小2', account: '99999999990000000011', name: "k2", crypto: '4f546b354f5445794d7a45774d4441774d5445745957466859574668' },
          { title: '教材小3', account: '99999999990000000012', name: "k3", crypto: '4f546b354f5445794d7a45774d4441774d5449745957466859574668' },
          { title: '教材小4', account: '99999999990000000013', name: "k4", crypto: '4f546b354f5445794d7a45774d4441774d544d745957466859574668' },
          { title: '教材小5', account: '99999999990000000014', name: "k5", crypto: '4f546b354f5445794d7a45774d4441774d5451745957466859574668' },
          { title: '教材小6', account: '99999999990000000015', name: "k6", crypto: '4f546b354f5445794d7a45774d4441774d5455745957466859574668' },
          { title: '教材小卒業', account: '99999999990000000016', name: "k7", crypto: '4f546b354f5445794d7a45774d4441774d5459745957466859574668' },
          { /* divider */ },
          { title: 'ベーシック　配送小5(前年アドバンス)', account: '99999999990000000017', name: "x19", crypto: '4f546b354f5445794d7a45774d4441774d5463745957466859574668' },
          { title: 'ストーリーマスター　教材小卒業(前年エキスパート)', account: '99999999990000000018', name: "x20", crypto: '4f546b354f5445794d7a45774d4441774d5467745957466859574668' },
          { title: 'アドバンス　配送小2(前年ベーシック)', account: '99999999990000000019', name: "x21", crypto: '4f546b354f5445794d7a45774d4441774d546b745957466859574668' },
          { title: 'ベーシック　小1', account: '99999999990000000121', name: "x22", crypto: '4f546b354f5445794d7a45774d4441784d6a45745957466859574668' },
        ]
        this.submitTestLinks = [
          // account=会員ID  opId=テスト提出への会員ログイン制御用ID
          { title: '小1', account: '80008606949755082448', name: "st1", opId: '20210617130454-AHGbMS' },
          { title: '小2', account: '99945096242789025260', name: "st2", opId: '20210617152430-4IuNbD' },
          { title: '小3', account: '27129063752836688218', name: "st3", opId: '20210617153729-c1h8gK' },
          { title: '小4', account: '34222576633536593844', name: "st4", opId: '20210617153936-TTCWjH' },
          { title: '小5', account: '33044022668486807937', name: "st5", opId: '20210617154548-rJBqmT' },
          { title: '小6', account: '96075913267235795515', name: "st6", opId: '20210617154829-h3A38y' },
          { title: '小1', account: '13660689700309276359', name: "st1-2", opId: '20210628155416-TAOXaL' },
          { title: '小2', account: '11046937198029161410', name: "st2-2", opId: '20210628155802-movduk' },
          { title: '小3', account: '76840758505476312088', name: "st3-2", opId: '20210628160133-R3P1tb' },
          { title: '小4', account: '10147995807145232126', name: "st4-2", opId: '20210628161315-GyGZ9r' },
          { title: '小5', account: '77870465404064759900', name: "st5-2", opId: '20210628161805-G3ImyA' },
          { title: '小6', account: '62342164841835657339', name: "st6-2", opId: '20210628162137-6cMJSj' },
        ]
        this.authError = ''
        this.isAuthed = true
        this.saveAuthData({
            userId: this.userId,
            password: this.password
        })
      } else {
        this.authError = '認証エラー'
      }
    },

    vdropzoneSending (file: any, xhr: any) {
      this.isLoading = true
      // this.$app.$refs.loading.open({message: '処理中です。少々お待ちください。'})
      // xhr.responseType = 'blob'
      // xhr.dataType = 'binary'
    },
    async vdropzoneSuccess (file: any, response: any) {
      if (response.error) {
        this.vdropzoneErrors = [response.error]
        this.vdropzoneSuccessStr = ""
      } else {
        this.vdropzoneErrors = []
        this.vdropzoneSuccessStr = "アップロードが完了しました"
      }
      // const res = file.xhr.response
      // const contentType = res.type
      // if (contentType === 'application/json') {
      //   // エラー
      //   this.vdropzoneErrors = JSON.parse(await res.text()).messages
      //   this.vdropzoneSuccessStr = null
      // }else{
      //   const blob = new Blob([res], { type: contentType})
      //   //レスポンスヘッダからファイル名を取得
      //   const contentDisposition = file.xhr.getResponseHeader('Content-Disposition')
      //   const fileName = this.getFileName(contentDisposition)
      //   saveAs(blob, fileName)

      //   this.vdropzoneErrors = []
      //   await this.getSchools()
      //   this.vdropzoneSuccessStr = 'CSVアップロードが完了しました'
      // }
    },
    vdropzoneComplete(){
      this.isLoading = false
      // this.$app.$refs.loading.close()
    },

    // 指定したユーザのテスト情報一覧を取得
    async loadSubmitTestInfo() {
      if (!(this.$refs.submitTestResetStatusForm as any).validate()) return;
      try {
        this.submitTestInfo = []
        // この認証情報の送り方は本来会員ユーザ向けのものですが、非会員ユーザもこの方法で動きます
        const response = await axios.get(
          '/api/v1/submit/tests',
          { dataType: 'application/json', headers: { 'submit-member-id': this.submitTestLoginId } }
        )
        this.submitTestInfo = response.data?.datas
      } catch(e) {
        console.error(e)
      }
    },
    submitTestStatusText(individual_data: any) {
      if (individual_data) {
        return individual_data.status + " " + (individual_data.submit_date || '')
      } else {
        return 'null'
      }
    },
    // 指定したテストの提出状況をリセット
    async submitTestResetStatus(submitTest: any) {
      if (!(this.$refs.submitTestResetStatusForm as any).validate()) return;
      try {
        this.isLoading = true
        const examp_group_key = submitTest.exam_group_key
        const response = await axios.delete(
          `/api/v1/submit/tests/${examp_group_key}`,
          { dataType: 'application/json', headers: { 'submit-member-id': this.submitTestLoginId } }
        )
        // 一応講師サイト側の状態変化を待つ
        await this.sleep(1000)
        await this.loadSubmitTestInfo()
      } catch(e) {
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    sleep(ms: number): Promise<void> {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  }
})
